var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 22.042q-1.625 0-2.708-1.125-1.084-1.125-1.084-2.75V7.917q0-1.542 1.104-2.646Q18.417 4.167 20 4.167q1.583 0 2.688 1.104 1.104 1.104 1.104 2.646v10.25q0 1.625-1.084 2.75-1.083 1.125-2.708 1.125Zm0-8.917Zm-1.042 21.458v-5.75q-4.166-.416-6.979-3.458-2.812-3.042-2.812-7.208h2.083q0 3.625 2.562 6.125 2.563 2.5 6.188 2.5 3.625 0 6.188-2.5 2.562-2.5 2.562-6.125h2.083q0 4.166-2.812 7.208-2.813 3.042-6.979 3.458v5.75ZM20 19.958q.708 0 1.188-.52.479-.521.479-1.313V7.917q0-.709-.479-1.188-.48-.479-1.188-.479t-1.188.479q-.479.479-.479 1.188v10.208q0 .792.479 1.313.48.52 1.188.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.c023c853ecb7ad8bdf7719c9738281bb.svg";
export { ForwardRef as ReactComponent };